module.exports = __webpack_public_path__ + "cf1f2ad6294502af77690404b3f660b5.jpg";